import { Injectable } from "@angular/core";
import { IShape } from "../interfaces/IShape";
import { Team } from "../../models/team";
import { teamUndefined } from "../shapes/team-undefined";
import {TeamType} from "../../_utils/teamType";
import { teamStreamAligned } from "../shapes/team-stream-aligned";
import { teamComplicatedSubsystem } from "../shapes/team-complicated_subsystem";
import { teamEnabling } from "../shapes/team-enabling";
import { teamPlatform } from "../shapes/team-platform";

@Injectable({
    providedIn: "root",
})

export class ShapeBuilder {

    buildTeamShape(team: Team): IShape {
        
        
        switch (team.teamType) {
            case TeamType.Undefined: {
                console.log("create an Undefined team : {{team.name}}");
                return new teamUndefined().setName(team.name);
            }
            case TeamType.streamAligned: {
                console.log("create a Stream aligned team : {{team.name}}");
                return new teamStreamAligned().setName(team.name);
            }
            case TeamType.complicatedSubsystem: {
                console.log("create a Complicated Subsystem team : {{team.name}}");
                return new teamComplicatedSubsystem().setName(team.name);
            }
            case TeamType.enabling: {
                console.log("create a Enabling team : {{team.name}}");
                return new teamEnabling().setName(team.name);
            }
            case TeamType.platform: {
                console.log("create a Platform team : {{team.name}}");
                return new teamPlatform().setName(team.name);
            }
            default: {
                return new teamUndefined().setName(team.name);
            }
        }

    }

}